import { cn } from "@/lib/utils";

interface ThoughtBubbleProps {
  title: string;
  body: string;
  rubricDriver: string;
  index: number;
  className?: string;
}

const driverColors: Record<string, string> = {
  goal_clarity: "from-primary/20 to-primary/5 border-primary/30",
  context: "from-secondary/20 to-secondary/5 border-secondary/30",
  constraints: "from-accent/20 to-accent/5 border-accent/30",
  output_format: "from-success/20 to-success/5 border-success/30",
  quality_control: "from-highlight-orange/20 to-highlight-orange/5 border-highlight-orange/30",
};

const driverLabels: Record<string, string> = {
  goal_clarity: "Goal",
  context: "Context",
  constraints: "Constraints",
  output_format: "Format",
  quality_control: "Quality",
};

const ThoughtBubble = ({ title, body, rubricDriver, index, className }: ThoughtBubbleProps) => {
  const colorClass = driverColors[rubricDriver] || driverColors.goal_clarity;
  const label = driverLabels[rubricDriver] || rubricDriver;

  return (
    <div
      className={cn("fade-in-up opacity-0", className)}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className={`h-full bg-gradient-to-br ${colorClass} border rounded-xl p-4 backdrop-blur-sm`}>
        <span className="inline-block text-[10px] uppercase tracking-wider text-muted-foreground font-medium mb-2 px-2 py-0.5 rounded-full bg-muted/50">
          {label}
        </span>
        <h4 className="font-display font-semibold text-sm text-foreground mb-1.5">{title}</h4>
        <p className="text-xs text-muted-foreground leading-relaxed">{body}</p>
      </div>
    </div>
  );
};

export default ThoughtBubble;
